import { CreateElement } from 'src/vue'
import { Component, Prop } from 'vue-property-decorator'
import Vue from 'vue'

import './member-activities-tooltip.sass'
import Activity from '@src/data/activity'
import { OptionGroup } from '@src/elements/select/option-group'
import { Select } from '@src/elements/select/select'
import { Option } from '@src/elements/select/option'
import { TimePicker } from '@src/elements/input/time-picker'
import { Subtitle1 } from '@src/elements/typography/typography'
import { DatePicker } from '@src/elements/input/date-picker'
import { Button } from '@src/elements/button/button'
import { Divider } from '@src/elements/divider/divider'
import { ADD_A_COMPLETED_ACTIVITY_KEY, PLAN_AN_ACTIVITY_KEY } from '@src/util/constants'
import { API } from '@src/lib/api_path'
import ApiClient from '@src/lib/api_client'
import { MemberActivityStatusType } from '@src/routes/members/member-activities'

@Component({
  computed: {
    activities () {
      return this.$store.state.activities || []
    }
  }
})
export class MemberActivitiesTooltip extends Vue {

  @Prop({ required: true })
  private closeCallback: (loadActivities?: boolean) => void

  private activities: Activity[]

  private selectedActivity: { id: number, key: string } = { id: 0, key: '' }

  private preventAccidentalClose: boolean = false

  private selectedActivityType: string = ''

  private minutes: string = ''
  private hours: string = ''

  private date: string = ''

  private apiClient: ApiClient

  constructor () {
    super()
    this.apiClient = new ApiClient()
  }
  close () {
    this.selectedActivity = { id: 0, key: '' }
    if (this.closeCallback) {
      this.closeCallback()
    }
  }

  mouseDown (e) {
    let path = e.composedPath && e.composedPath()
    if (!path) return

    let clickedInside = path.filter((el) => {
      // if mousedown event occurs inside the modal, it means the user is selecting some text and the modal should
      // not close if the user releases the mouse outside the modal
      return el && el.classList && el.classList.contains('member-activities-tooltip')
    }).length
    this.preventAccidentalClose = clickedInside
  }

  mouseUp () {
    if (!this.preventAccidentalClose) {
      this.close()
    }
    this.preventAccidentalClose = false
  }

  mounted () {
    window.addEventListener('mousedown', this.mouseDown)
    window.addEventListener('mouseup', this.mouseUp)
  }

  beforeDestroy () {
    window.removeEventListener('mousedown', this.mouseDown)
    window.removeEventListener('mouseup', this.mouseUp)

    this.selectedActivity = { id: 0, key: '' }
    this.selectedActivityType = ''
    this.hours = ''
    this.minutes = ''
  }

  resetActivityTypeSelected () {
    this.selectedActivityType = ''
  }

  setSelectedActivityType (activityType) {
    this.selectedActivityType = activityType
  }

  setDate (value) {
    this.date = value
  }

  save () {
    const amount = Number(this.hours) * 3600 + Number(this.minutes) * 60
    const data = {
      member_activity: {
        status: this.selectedActivityType === PLAN_AN_ACTIVITY_KEY ? MemberActivityStatusType.PLANNED : MemberActivityStatusType.COMPLETED,
        activity_id: this.selectedActivity.id,
        amount,
        started_at: this.date
      }
    }
    return this.apiClient.post(API.MEMBERS_API.MEMBER_ACTIVITIES, data).finally(() => this.closeCallback(true))
  }

  render (h: CreateElement) {
    const activities = this.activities.map(activity => {
      return <Option type='single-option' value={activity.id.toString()} label={this.$t(`ACTIVITIES.${activity.key.toUpperCase()}`)}
                     selected={(this.selectedActivity && this.selectedActivity.id === activity.id)}
                     select={() => {
                       this.selectedActivity = { id: activity.id, key: activity.key }
                     }} />
    })

    const options: any[] = [PLAN_AN_ACTIVITY_KEY, ADD_A_COMPLETED_ACTIVITY_KEY].map(option => {
      return <span class='option activity-type' onClick={() => this.setSelectedActivityType(option) }><Subtitle1>{this.$t(option)}</Subtitle1></span>
    })

    if (this.selectedActivityType) {
      const saveButtonEnabled = this.selectedActivity.key && (Number(this.hours) || Number(this.minutes)) && this.date
      return <div class='tooltip member-activities-tooltip with-padding'>
        <div class={`${this.selectedActivityType ? 'arrow' : /* istanbul ignore next: the type is checked above */ ''} tooltip-title`} ref='title' onClick={this.resetActivityTypeSelected}>
          <span>{this.$t(this.selectedActivityType)}</span>
        </div>

        <span>{this.$t(`PAGE.MEMBERS.GOALS.KGI.ACTIVITY`)}</span>
        <Select label={this.$t('CHOOSE_FROM_LIST')} value={this.selectedActivity.key ? this.$t(`ACTIVITIES.${this.selectedActivity.key.toUpperCase()}`) : ''}>
          <OptionGroup>{activities}</OptionGroup>
        </Select>

        <DatePicker
          appendToBody={false}
          label={this.$t('DATE')}
          class='edit-date'
          value={this.date}
          allowPastDate={this.selectedActivityType === ADD_A_COMPLETED_ACTIVITY_KEY}
          allowFutureDate={this.selectedActivityType === PLAN_AN_ACTIVITY_KEY}
          firstAvailableDate={new Date()} type='date' change={this.setDate} icon='util/calendar'/>

        <div class='time'>
          <TimePicker
            description={this.$t('DURATION')}
            valueHours={this.hours}
            minValueHours={0} maxValueHours={23}
            changeHours={(value) => {
              this.hours = value
            }}
            valueMinutes={this.minutes}
            minValueMinutes={0}
            maxValueMinutes={59}
            changeMinutes={(value) => {
              this.minutes = value
            }}
          />
        </div>
        <Divider />
        <div class='button-wrapper'>
          <Button label={this.$t('SAVE')} class='save-btn' ref='saveBtn' click={this.save} disabled={!saveButtonEnabled} />
        </div>
      </div>
    }

    return (
      <div class='tooltip member-activities-tooltip'>
        {options}
      </div>
    )
  }
}
